export default __webpack_public_path__ + "static/media/heroBannerAppKO.337bc37b.png";